/**
 * 对【服务器推过来的消息】进行处理
 * 过滤除 a标签外所有标签
 * a标签 仅支持标准格式（<a href="baidu.com"></a>），a标签中href后面多余内容会被过滤（如<a href="baidu.com" onclick="alert(666)"></a>中onclick部分会被过滤）
 * 文本中链接可渲染成a标签，可直接点击在新窗口打开
 * emoji code 转换为 img
 */

import { emoji } from '@/components/TheFooter/components/TheEmojiPanel/data'
import { pattern } from '@/utils/pattern'

const aLabelReg = /&lt;a\s+[(target="_blank"\s*)(rel="noreferrer"\s*)]*href=(?:'|").*?(?:'|").*?&gt;.*?&lt;\/a&gt;/g
const aLabelHrefReg = /&lt;a\s+[(target="_blank"\s*)(rel="noreferrer"\s*)]*href=(?:'|")(.*?)(?:'|")(.*?)&gt;.*?&lt;\/a&gt;/
const urlReg = '(http(s)?://.)?(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%_\\+.~#?(&|&amp;)//=]*)'
const { emojiRegex, emojiHash, emojiSign } = genEmojiParam(emoji)
// url 处理
function isUrl (str) {
    return new RegExp(urlReg, 'i').test(str)
}
function genCheckURL (e) {
    return (e.indexOf('http') === 0 ? '' : '//') + clearHtmlStr(e)
}
function clearHtmlStr (e) {
    return e ? e.replace(/<[^>]*>/g, '') : e
}
function htmlEncode (e) {
    if (e.constructor === String) {
        return e.replace(/</g, '&lt;').replace(/>/g, '&gt;')
    }
    return e
}
function htmlDecode (e) {
    return e && 0 !== e.length ? e.replace(/&lt;/g, '<').replace(/&gt;/g, '>') : e
}
function hrefEncode (str) {
    // app如无处理 CreateWindow 事件会导致a标签点击无反应
    let target = judgePC() ? ' target="_blank"' : ''
    const arr = str.match(aLabelReg)
    let aLabelHref = []
    if (arr) {
        for (let n, i, o = 0, r = arr.length; o < r; ++o) {
            let tem_arr_item = arr[o].replace(/target="_blank"\s*/g, '')
            str = str.replace(arr[o], tem_arr_item)
            n = aLabelHrefReg.exec(tem_arr_item)
            if (n && n[1]) {
                i = n[1]
                if (isUrl(i)) {
                    const href = genCheckURL(n[1])
                    aLabelHref.push(href)
                    let s = n[0].replace(n[2], '').replace(n[1], href)
                    // 添加 target
                    const urlNextIndex = s.indexOf(href) + href.length
                    // let target = ' target="_blank"'
                    if (n[2].match('data-attachment="inline"')) {
                        target += ' data-attachment="inline"'
                    }
                    s = s.substr(0, urlNextIndex + 1) + target + s.substr(urlNextIndex + 1, s.length - urlNextIndex)
                    s = htmlDecode(s)
                    str = str.replace(n[0], s)
                }
            }
        }
        // return str
    }
    return str = str.replace(new RegExp(urlReg, 'ig'), res => {
        if (aLabelHref.indexOf(res) !== -1) {
            return res
        }
        const href = genCheckURL(res.replace(/^(\s|\n)/, ''))
        return `<a href="${href}"${target}>${res}</a>`
    })
}

// emoji 处理
function genEmojiParam (list) {
    const specialCharReg = /(\/|\^|\$|\(|\)|\[|\]|\{|\}|\.|\?|\+|\*|\\|\|)/g
    let emojiHash = {}
    let emojiSign = {}
    let codeList = []
    list.forEach(item => {
        emojiHash[htmlEncode(item.code)] = emojiHash[htmlEncode(item.sign)] = item.uri
        codeList.push(handle(item.code), handle(item.sign))
        emojiSign[htmlEncode(item.code)] = emojiSign[htmlEncode(item.sign)] = item.sign
    })
    return {
        emojiRegex: `(${codeList.join('|')})`,
        emojiHash,
        emojiSign
    }

    function handle (str) {
        return htmlEncode(str.replace(specialCharReg, '\\$1'))
    }
}
function encodeEmojiSpecial (e) {
    return e = e || '', e = e.replace(new RegExp(emojiRegex, 'g'), ' ###__EMOJI__$1__### ')
}
function encodeEmojiImg (e) {
    e = e || ''
    return e.replace(new RegExp(` ###__EMOJI__${emojiRegex}__### `, 'g'), res => {
        const code = res.match(new RegExp(emojiRegex))[0]
        const url = emojiHash[code]
        const sign = emojiSign[code]
        return `<img src="${url}" class="emoji-icon" title="${sign}">`
    })
}
function telEncode (str) {
    // const reg = /((1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8})|(0\d{2,3}-\d{7,8}))/g
    const reg = pattern('tel')
    return str.replace(reg, res => {
        return `<a href="tel:${res}">${res}</a>`
    })
}

function judgePC () {
    let userAgentInfo = navigator.userAgent
    let Agents = ['Android', 'iPhone',
        'SymbianOS', 'Windows Phone',
        'iPad', 'iPod']
    let flag = true
    for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false
            break
        }
    }
    return flag
}

const handle = (str) => {
    if (!str || str.constructor !== String) {
        return str
    }
    str = htmlEncode(str) // 将 字符串中 html特殊字符 转换为 字符命名实体/十进制编码
    str = encodeEmojiSpecial(str) // 将emoji code转换为 emoji特殊字符串 备用
    if (window.__wxjs_environment !== 'miniprogram') {
        str = hrefEncode(str) // 提取 字符串中 链接，包含 文本中链接 和 a标签
    }
    str = encodeEmojiImg(str) // 将第一步中编码的 emoji特殊字符串 转换为 img标签
    str = telEncode(str) // 电话号码识别
    return str.replace(/\n/gi, '<br>')
}

export default handle
